export class ScheduleApiService {
  constructor(http) {
    this.http = http;
  }

  async generate(data) {
    const response = await this.http.post('/generate/for_doctor/', data);
    return response;
  }
  async clear(data) {
    const response = await this.http.post('/clear/for_doctor/', data);
    return response;
  }
}
